import { cn } from "@/lib/utils";

type DiscountGradientIconProps = {
  className?: string;
  children?: React.ReactNode;
};

export const DiscountGradientIcon = ({
  className,
  children,
}: DiscountGradientIconProps) => {
  return (
    <span
      className={cn(
        "bg-(image:--discount-gradient-icon) flex h-8 w-8 shrink-0 items-center justify-center rounded-[8px] font-medium text-shadow-[0_1px_0_rgba(0,0,0,0.26)] text-white",
        className
      )}
    >
      {children || "%"}
    </span>
  );
};
